module.exports = __webpack_public_path__ + "img/hr-chemical-plant-shadow.e22cc71e.png";